import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './weatherWidget.css';
import { HeaderIcon } from '../headerIcon';
import { updateWeatherCredit } from '../../actions.js';
import { Popup } from '../../component/popup/';
import Api from '../../../ui/src/api.js';
import { Icon } from '../../../ui/src/component/icon';
import Cookies from 'js-cookie';
import moment from 'moment';
import { getProp } from '../../../ui/src/utilities';

class WeatherWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popupOpened: false,
      weatherLocations: [],
      currentWeatherLocation: null,
      forecast: [],
    };
    this.cookiekey = 'weatherlocation';
    
    this.onClickPopupItem = this.onClickPopupItem.bind(this);
  }

  componentDidMount() {
    Api.get('/weather/locations').then(response => {
      this.setState({ weatherLocations: response.locations }, () => {
        // get current location from cookies
        let locationSet = false;
        let weatherLocation = Cookies.get(this.cookiekey);
        if (weatherLocation) {
          for (let location of getProp(this.state, 'weatherLocations', [])) {
            if (location._id === weatherLocation) {
              this.setNewLocation(weatherLocation);
              locationSet = true;
              break;
            }
          }
        }

        // no location stored, set the default one
        if (!locationSet) {
          this.setNewLocation('kosice');
        }
      });
    });
  }

  setNewLocation(locationId) {
    Cookies.set(this.cookiekey, locationId);
    let newLoc = null;
    for (let location of getProp(this.state, 'weatherLocations', [])) {
      if (location._id === locationId) {
        newLoc = location;
        break;
      }
    }

    if (newLoc) {
      Api.get(`/weather/forecast/${newLoc._id}`).then(response => {
        this.setState({
          forecast: response.forecast,
          currentWeatherLocation: newLoc,
        });
        this.props.dispatch(updateWeatherCredit(response.credit));
      });
    }
  }

  onClickPopupItem(item) {
    this.setNewLocation(item._id);
    this.setState({ popupOpened: false });
  }

  render() {
    return (
      <div className="weather-container">
        <div className="h1 font-medium" style={{ fontWeight: '400' }}>
          Počasie{' '}
          <span className="text-primary font-light">
            {getProp(this.state, 'currentWeatherLocation.name')}
          </span>&nbsp;
          <span style={{ position: 'relative', display: 'inline-block' }}>
            <button
              className="btn btn-primary btn-xs text-uppercase popup-trigger"
              onClick={() =>
                this.setState({ popupOpened: !this.state.popupOpened })
              }
            >
              zmeniť
            </button>
            <span className="popup-container">
              <Popup
                eventTypes="click"
                opened={this.state.popupOpened}
                items={getProp(this.state, 'weatherLocations', []).map(item => (
                  <a
                    key={item._id}
                    onClick={e => {e.preventDefault(); this.onClickPopupItem(item)}}
                    href=""
                  >
                    {item.name}
                  </a>
                ))}
                handleClickOutside={() => this.setState({ popupOpened: false })}
                outsideClickIgnoreClass={'popup-trigger'}
              />
            </span>
          </span>
        </div>
        <div className="row">
          {this.state.forecast.map((item, idx) => {
            return (
              <DayForecast
                key={idx}
                date={item.from}
                pressure={item.pressure}
                temperature={item.temperature}
                temperatureMin={item.temperature_min}
                wind={item.wind}
                image={getProp(item, 'symbol.url', null)}
                precipitation={item.precipitation}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

export default connect()(WeatherWidget);

WeatherWidget.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const DayForecast = props => {
  const {
    temperature: { value },
    temperatureMin: { value: minValue },
  } = props;
  const date = moment(props.date).startOf('day');
  let dateStr = date.format('dddd, D.M.YYYY');
  dateStr = `${dateStr[0].toLocaleUpperCase()}${dateStr.substr(1)}`;
  let diff = date.diff(moment().startOf('day'), 'day');
  let dateWord = dateStr;
  if (diff === 0) {
    dateWord = 'Dnes';
  } else if (diff === 1) {
    dateWord = 'Zajtra';
  } else if (diff === 2) {
    dateWord = 'Pozajtra';
  } else {
    let day = date.format('dddd');
    dateWord = `${day[0].toLocaleUpperCase()}${day.substr(1)}`;
  }

  let temp = (
    <span>
      <strong>{value}°C</strong>
      {' / '}
      <span className="text-primary">
        <strong>{value}°C</strong>
      </span>
    </span>
  );
  if (value && minValue) {
    temp = (
      <span>
        <strong>{minValue}°C</strong>
        {' / '}
        <span className="text-primary">
          <strong>{value}°C</strong>
        </span>
      </span>
    );
  }

  // teplota
  let desc = [
    <span key="teplota" style={{ whiteSpace: 'nowrap' }}>
      Teplota {temp}
    </span>,
  ];

  // zrazky
  if (props.precipitation.value) {
    desc.push(
      <span style={{ whiteSpace: 'nowrap' }}>
        Zrážky {props.precipitation.value} {props.precipitation.unit}
      </span>,
    );
  }
  // if (props.pressure.value) {
  //     desc.push(<span style={{ whiteSpace: 'nowrap' }}>Tlak {props.pressure.value} {props.pressure.unit}</span>);
  // }
  if (getProp(props, 'wind')) {
    let windSpeed = getProp(props.wind, 'speed.value', 0);
    windSpeed *= 3.6;
    let deg = getProp(props.wind, 'dir_deg', 0) - 45 - 180; // -45, pretoze ikonka je defaultne natocena do uhla 45 stupnov; -180, pretoze ikonku potrebujeme natocit do opacnej strany
    desc.push(
      <span style={{ whiteSpace: 'nowrap' }}>
        Vietor{' '}
        <span
          style={{ display: 'inline-block', transform: `rotate(${deg}deg)` }}
        >
          <Icon name="archers-arrow" />
        </span>{' '}
        {windSpeed.toFixed(2)}km/h
      </span>,
    );
  }

  return (
    <div className="col-sm-4">
      <div>
        <HeaderIcon
          customIcon={<img src={props.image} alt=""/>}
          title={dateWord}
          subtitle={dateStr}
        />
        <div>
          {desc.map((item, idx) => (
            <span key={idx}>
              {item}
              <br />
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

DayForecast.propTypes = {
  image: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  precipitation: PropTypes.object.isRequired,
  pressure: PropTypes.object.isRequired,
  wind: PropTypes.object,
  temperature: PropTypes.shape({
    unit: PropTypes.string,
    value: PropTypes.number,
  }).isRequired,
  temperatureMin: PropTypes.shape({
    unit: PropTypes.string,
    value: PropTypes.number,
  }),
};



// WEBPACK FOOTER //
// ./src/app/component/weatherWidget/weatherWidget.js